"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = popAlpha;
/**
 *
 * @param {Pixel} pixel - an RGBA Pixel, an Array of 4 Numbers [Red, Green, Blue, Alpha]
 * @returns {RGBA} an RGB Pixel, an Array of 3 Numbers [Red, Green, Blue]
 */
function popAlpha(pixel) {
  pixel.pop();
  // @ts-ignore
  return pixel;
}